import React, { useEffect, useState, useRef } from "react";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import HomeService from "../../../Services/HomeService";
import Swal from "sweetalert2";
import moment from "moment";

const headLineStyle = {
  textAlign: "center",
  fontSize: "30px",
  color: "#868e96",
  margin: "15px",
  fontWeight: "bold",
};

const ManageMiscellaneous = () => {

  const userRole = localStorage.getItem("role");
  const userCity = localStorage.getItem("city");
  const loggedUserID = localStorage.getItem("uid");
  const [allData, setAllData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isEdit, setIsEdit] = useState(false);

  const [months, setMonths] = useState([
    { id: 1, name: "January" },
    { id: 2, name: "February" },
    { id: 3, name: "March" },
    { id: 4, name: "April" },
    { id: 5, name: "May" },
    { id: 6, name: "June" },
    { id: 7, name: "July" },
    { id: 8, name: "August" },
    { id: 9, name: "September" },
    { id: 10, name: "October" },
    { id: 11, name: "November" },
    { id: 12, name: "December" }
  ]);

  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 5 }, (_, index) => ({
    id: index,
    name: currentYear - 2 + index
  }));

  const initialFormData = {
    city: "",
    price: 0,
    remarks: "",
    date: "", //2025-01-19
    month: "",
    year: "",
    addedBy: loggedUserID,
  }

  const [editData, setEditData] = useState(initialFormData);
  const [editID, setEditID] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const navigate = useNavigate();

  const fetchAllData = async () => {
    try {
      const res = await HomeService.getMiscellenious();

      console.log("UYT66", res.data)
      if (res?.status) {
        if (userCity) {
          setAllData(res.data.filter((item) => item?.city._id === userCity) || []);
        } else {
          setAllData(res.data || []);
        }
      } else {
        toast.error("Failed to fetch allData.");
      }
    } catch (error) {
      toast.error("Error fetching allData.");
      console.error("Error fetching allData:", error);
    } finally {
      setLoading(false);
    }
  };

  const [cities, setCities] = useState([]);
  const fetchCities = async () => {
    try {
      const res = await HomeService.getCities();
      if (res?.status) {
        if (userCity) {
          setCities([res.data.find(item => item._id === userCity)])
          // fetchLocalities(userCity)
        } else {
          setCities(res.data);
        }
      } else {
        toast.error("Failed to fetch cities.");
      }
    } catch (error) {
      toast.error("Error fetching cities.");
      console.error("Error fetching cities:", error);
    }
  };

  const handleEdit = (row) => {
    console.log("OIUY102", row);

    setIsEdit(true);
    setAllSelected(false)

    // const editSection = document.getElementById("edit-section");
    // if (editSection) {
    //   editSection.scrollIntoView({
    //     behavior: "smooth",
    //     block: "start",
    //   });
    // }

    setEditID(row._id);
    setProducts(row?.products.map(({ _id, ...rest }) => rest))

    setEditData({
      ...row,
      city: row?.city?._id,
      date: row?.date?.split("T")[0],
    });
  };

  const toggleStatus = async (id, currentStatus) => {
    try {
      const newStatus = currentStatus === true ? false : true;
      await HomeService.updateMiscelleniousStatus(id, { status: newStatus });
      fetchAllData();
      toast.success(`Status updated successfully`);
    } catch (error) {
      // toast.error("Failed to update Commission status.");
      console.error("Error updating status:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      console.log("IUY151", editData);
      // return

      const res = await HomeService.updateMiscellenious(
        editID,
        editData
      );

      if (res) {
        toast.success("Miscellenious updated successfully!");
        setIsEdit(false);
        fetchAllData();
      }
    } catch (error) {
      toast.error("Failed to update Miscellenious.");
      console.error("Error saving Miscellenious:", error);
    }
  };

  const handleCityChange = (e) => {
    const value = e.target.value;
    setEditData((prevData) => ({
      ...prevData,
      cityNames: prevData.cityNames.includes(value)
        ? prevData.cityNames.filter((city) => city !== value)
        : [...prevData.cityNames, value],
    }));
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: `Delete Subscription?`,
      text: "Are you sure you want to delete this Subscription?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      confirmButtonColor: "#d33",
      cancelButtonText: "Cancel",
      reverseButtons: true,
    });
    if (result.isConfirmed) {
      try {
        const res = await HomeService.deleteSubscription(id);
        if (res?.status) {
          Swal.fire("Deleted!", "Subscription has been deleted.", "success");
          fetchAllData()
        }
      } catch (error) {
        Swal.fire("Error!", "Failed to delete Subscription.", "error");
      }
    }
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const columns = [
    {
      name: "Date",
      selector: (row) => moment(row?.date?.split("T")[0]).format("DD-MM-YYYY"),
      sortable: true,
    },
    {
      name: "City",
      selector: (row) => row?.city?.name,
      sortable: true,
    },
    {
      name: "Items",
      cell: (row) => (
        <>
        <ol>
        {
          row.products.map((item)=>{
            return (<li>{`${item?.productName}`} &nbsp;<i class="fas fa-indian-rupee-sign"></i>{`${item?.price}`}</li>)
          })
        }
        </ol>
        </>
      ),
      sortable: true,
    },
    {
      name: "Month",
      selector: (row) => row?.month,
      wrap: true,
    },
    {
      name: "Year",
      selector: (row) => row?.year,
      wrap: true,
    },
    {
      name: "Remarks",
      selector: (row) => row?.remarks,
      wrap: true,
    },
    {
      name: "Status",
      cell: (row) => (
        <button
          className={`btn btn-${row.status ? "success" : "danger"}`}
          onClick={() => toggleStatus(row._id, row.status)}
        >
          {row.status ? "Active" : "Inactive"}
        </button>
      ),
      sortable: true,
    },
    {
      name: "Actions",
      cell: (row) => (
        <>
          <span title="Edit" onClick={() => handleEdit(row)}>
            <i
              className="fa-solid fa-pen-to-square"
              style={{
                cursor: "pointer",
                padding: "5px",
                marginRight: "5px",
                fontSize: "1.5em",
                color: "rgb(133, 218, 79)",
                backgroundColor: "#E9F3F7",
              }}

            ></i>
          </span>

          {/* <span title="Delete" onClick={() => handleDelete(row._id)}>
            <i
              className="fa-solid fa-trash-can text-danger"
              style={{
                cursor: "pointer",
                padding: "5px",
                marginRight: "5px",
                fontSize: "1.5em",
                color: "#477DA5",
                backgroundColor: "#E9F3F7",
              }}
            ></i>
          </span> */}
        </>
      ),
    },
  ];

  const formatDateForDisplay = (date) => {
    if (!date) return ""; // Handle empty or invalid dates
    const [year, month, day] = date.split("-");
    return `${day}/${month}/${year}`;
  };

  const handleLocalityChange = (e) => {
    const value = e.target.value;
    console.log("UYT172", value);

    setEditData((prevData) => ({
      ...prevData,
      locality: prevData.locality.includes(value)
        ? prevData.locality.filter((item) => item !== value)
        : [...prevData.locality, value],
    }));
    setAllSelected(false)
  };

  const [allSelected, setAllSelected] = useState(false)


const initialProduct = {
    productName: "",
    price: 0,
  };

  const [products, setProducts] = useState([initialProduct]);
  const handleMultiChange = (i, e) => {
    let newFormValues = [...products];
    newFormValues[i][e.target.name] = e.target.value;
    setProducts(newFormValues);
    setEditData({ ...editData, products: newFormValues })
  };

  const addProducts = () => {
    // alert(products.length)
    if (products?.length < 5000) {
      setProducts([...products, initialProduct]);
    } else {
      // Swal("")
      // Swal("Error", "Not more than 5000", "error");
    }
  };

  const removeProducts = (i) => {
    let newFormValues = [...products];
    newFormValues.splice(i, 1);
    setProducts(newFormValues);
    setEditData({ ...editData, products: newFormValues })
  };






  useEffect(() => {
    fetchAllData();
    fetchCities();

  }, []);

  return (
    <div className="main_wrap" style={{ marginTop: "6rem" }}>
      <div className="container-fluid edit-section">
        {isEdit ? (
          <section className="chartBox_area">
            <h2>Edit Miscellaneous Details</h2>
            <hr />
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-6 mt-3">
                  <label>
                    City<span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="city"
                    value={editData.city}
                    onChange={(e) =>
                      setEditData({
                        ...editData,
                        city: e.target.value,
                      })
                    }
                  >
                    <option value="" disabled>---Select---</option>
                    {cities.map((city) => (
                      <option key={city._id} value={city._id}>
                        {city.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-md-6 mt-3">
                  <label>
                    Price<span className="text-danger">*</span>
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    name="price"
                    value={editData?.price || 0}
                    onChange={(e) =>
                      setEditData({
                        ...editData,
                        price: e.target.value,
                      })
                    }
                    placeholder="Enter price"
                  />
                </div>

                <div className="col-md-4 mt-3">
                  <label htmlFor="endDate">
                    Date<span className="text-danger">*</span>
                  </label>
                  <input
                    type="date"
                    name="date"
                    className="form-control"
                    value={editData?.date}
                    onChange={(e) =>
                      setEditData({
                        ...editData,
                        date: e.target.value,
                      })
                    }
                  />
                </div>

                <div className="col-md-4 mt-3">
                  <label>
                    Month<span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="month"
                    value={editData?.month || ""}
                    onChange={(e) =>
                      setEditData({
                        ...editData,
                        month: e.target.value,
                      })
                    }
                  >
                    <option value="" disabled>---Select---</option>
                    {months.map((item, index) => (
                      <option key={index} value={item.name}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-md-4 mt-3">
                  <label>
                    Year<span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="year"
                    value={editData?.year || ""}
                    onChange={(e) =>
                      setEditData({
                        ...editData,
                        year: e.target.value,
                      })
                    }
                  >
                    <option value="" disabled>---Select---</option>
                    {years.map((item, index) => (
                      <option key={index} value={item.name}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>




                <div className="col-md-12 mt-3">
                  <label>
                    Items <button
                      className="btn btn-sm btn-success"
                      type="button"
                      onClick={() => addProducts()}
                    >
                      <i class="fas fa-plus"></i> Add
                    </button>
                  </label>
                  {products?.map((element, index) => (

                    <div
                      style={{ border: "solid 1px #ced4da", padding: "1em", margin: "0 0 1em 0", borderRadius: "0.25rem" }}
                      className="_form-inline row" key={index}>

                      <div className="col-md-8 mb-2 mt-1">
                        <label>
                          Name:
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          name="productName"
                          placeholder={`Title ${index + 1}`}
                          value={element.productName || ""}
                          onChange={(e) => handleMultiChange(index, e)}
                        />
                      </div>

                      <div className="col-md-4 mb-2 mt-1">
                        <label>
                          Price:
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          name="price"
                          placeholder={`Price ${index + 1}`}
                          value={element.price || ""}
                          onChange={(e) => handleMultiChange(index, e)}
                        />
                      </div>

                      {index ? (
                        <div
                        style={{
                          position: "absolute",
                          right: "25px"
                        }}
                      >
                        <i class="fas fa-times"
                          style={{
                            color: "#ff0000",
                            cursor: "pointer",
                            fontSize: "1em"
                          }}
                          onClick={() => removeProducts(index)}
                        ></i>
                      </div>
                      ) : null}




                    </div>

                  ))}
                </div>






                <div className="col-md-12 mt-3">
                  <label htmlFor="endDate">
                    Remarks
                  </label>
                  <textarea
                    name="remarks"
                    className="form-control"
                    value={editData?.remarks || ""}
                    onChange={(e) =>
                      setEditData({
                        ...editData,
                        remarks: e.target.value,
                      })
                    }
                    placeholder="Enter remarks (if any)"
                  ></textarea>
                </div>




              </div>
              <button style={{
                background: 'rgb(133, 218, 79)',
                borderRadius: '13px'
              }} type="submit" className="btn mt-3">
                Submit
              </button>
              <button
                type="button"
                className="btn btn-secondary mt-3"
                style={{ marginLeft: "11px" }}
                onClick={() => setIsEdit(false)}
              >
                Cancel
              </button>
            </form>
          </section>
        ) : (
          <>
            <div className="mt-5">
              <div style={headLineStyle} className="page-headline">
                Manage Miscellaneous
              </div>
              <hr />
              <button type="submit" style={{
                background: '#fff',
                border: "solid 2px #85da4f",
                borderRadius: '13px',
                margin: '10px'
              }} className="btn mt-3"
                onClick={() => { navigate("/add-miscellaneous") }}
              >
                Add Miscellaneous
              </button>
              {loading ? (
                <p>Loading...</p>
              ) : (
                <section className="chartBox_area">
                  <DataTable
                    columns={columns}
                    data={allData}
                    progressPending={loading}
                    pagination
                    highlightOnHover
                  />
                </section>
              )}
            </div>
          </>
        )}


      </div>
    </div>
  );
};

export default ManageMiscellaneous;
